export default __webpack_public_path__ + "static/media/Image gallery element(1).c187e835.png";